import React from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const DatePickerFooter = ({ dateField, handleDateFieldChange }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Radio.Group
        buttonStyle="solid"
        size="small"
        value={dateField}
        onChange={(e) => handleDateFieldChange(e.target.value)}
      >
        <Radio.Button value="creation_date">
          {t(`header.menu.filteredTab.creationDateOrders`)}
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

DatePickerFooter.propTypes = {
  dateField: PropTypes.string.isRequired,
  handleDateFieldChange: PropTypes.func.isRequired
};

export default DatePickerFooter;
